import React, { useEffect, useRef, useState } from "react";
import gear from "../../../../../assets/image/services/gear.webp";
import fuelchange from "../../../../../assets/image/services/fuelchange.webp";
import fluidtransmission from "../../../../../assets/image/services/fluidtransmission.webp";
import clutch4 from "../../../../../assets/image/services/clutch4.webp";
import check from "../../../../../assets/image/check.png";
import { Link } from "react-router-dom";
import MyButton from "../../utils/Button/MyButton";
import image from "../../../../../assets/image/category/image.webp";

export default function Clutch() {
  const [isVisible, setIsVisible] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    // Trigger animation after component mounts
    setTimeout(() => setIsVisible(true), 100);
    const observer = new IntersectionObserver(
      ([entry]) => setIsVisible(entry.isIntersecting),
      { threshold: 0.1 }
    );
  }, []);
  return (
    <>
      <div className="overflow-hidden ">
        <div
          className="bg-gray-50 lg:h-[30rem] h-[19rem] md:h-[25rem]  w-[100%] bg-cover bg-center relative text-white"
          style={{ backgroundImage: `url(${image})` }}
        >
          <div class="absolute inset-0 bg-gradient-to-t from-[#2770ab]/65 to-transparent"></div>
          <div className="bg-black-700 bg-opacity-100 px-4   flex flex-col items-center justify-center text-center min-h-[320px] md:min-h-[500px]">
            <h3
              className={`text-gray-100  font-bold lg:text-6xl md:text-4xl absolute text-center lg:mb-20 md:mb-32 mb-16 
          transition-all duration-[5000ms] ease-out
                ${isVisible ? "opacity-100" : "opacity-0"}
              `}
            >
              Expert Clutch & Transmission Services
            </h3>

            <div
              className={`w-full text-center mx-auto flex items-start justify-center lg:mt-20 md:mb-16   mt-6 absolute 
           transition-all duration-[1050ms] ease-out
                ${
                  isVisible
                    ? "-translate-y-0 opacity-100"
                    : "translate-y-5 opacity-0"
                }
              `}
            >
              <Link to="/contact-us">
                {/* <button className="bg-orange-500 text-white px-6 py-3 rounded-full text-base sm:text-lg md:text-xl font-bold hover:bg-orange-600 hover:scale-105 transition-all shadow-md">
              Schedule Your Transmission Service
            </button> */}
                <MyButton
                  text=" Transmission Service"
                  className="bg-orange-500 text-white py-[11px]  rounded-full text-base sm:text-lg md:text-xl font-bold transform transition-transform duration-500 hover:scale-105 mt-4 shadow-md"
                />
              </Link>
            </div>
          </div>
        </div>

        {/* Clutch and Transmission Services Info Section */}
        <div className="bg-gradient-to-b from-white to-[#F8FAFC] py-[30px] lg:px-[12%]">
          <div className="container mx-auto px-5 max-w-4xl  text-center">
            <p className="text-xl lg:block md:block hidden text-gray-700 mb-6 leading-relaxed">
              Your vehicle’s transmission is key to a smooth and safe drive. If
              shifting gears feels rough, delayed, or unpredictable, it’s a sign
              you shouldn’t ignore. Small issues can turn into expensive repairs
              fast.
            </p>

           <p className="text-xl text-gray-700 mb-6">
  <strong className="text-gray-900">
    From fluid flushes to full repairs,
  </strong>{" "}
  Vancouver Auto Parts has you covered. Whether you’re hearing strange
  noises, experiencing slipping gears, or noticing fluid leaks, our certified
  technicians are here to keep your car running smoothly.
</p>

            <p className="lg:text-xl md:text-xl text-[1.3rem] font-semibold text-black g:mb-8 md:mb-8 mb-4">
              ✅ Book Your FREE Transmission Check Today!
            </p>
            <div
              className={`
           transition-all duration-[950ms] delay-[2500ms] ease-out
                ${
                  isVisible
                    ? "-translate-y-0 opacity-100"
                    : "translate-y-5 opacity-0"
                }
              `}
            >
              <Link to="/contact-us">
                {/* <button className="bg-orange-500 text-white text-lg px-8 py-3 rounded-full hover:bg-orange-600 hover:scale-105 transition-transform duration-200 shadow-md">
            Book Now
          </button> */}
                <MyButton
                  text="Book Now"
                  className="mx-auto transform transition-transform duration-500 hover:scale-105"
                />
              </Link>
            </div>
          </div>
        </div>

        <div className="bg-[#EFF6FF]">
          <div className=" py-[30px]  container  ">
            <h1 className="text-blue-900 font-bold text-center text-[2.23rem] md:text-[2.6rem] lg:text-[3rem] mb-3">
              Premium Clutch and Transmission Services
            </h1>
            <p className="mb-3 lg:font-normal text-[1.35rem] text-center  lg:px-[10%]  ">
              Your vehicle’s clutch and transmission system is essential for
              smooth and efficient power delivery to the wheels. When even one
              component starts to slip , it can impact your entire drivetrain.
              Our certified technicians deliver precise service across all
              vehicle types, using advanced tools and premium-grade parts.
            </p>

            <div className="flex justtify-center items-center lg:px-[5%]  sm:px-2 ">
              <div className="text-black text-center  h-[100%]  ">
                {/* first */}
                <div className=" flex lg:flex-row md:flex-col flex-col w-full max-h-[50%] my-[4%] justify-between  ">
                  <div className="lg:w-[50%] md:w-[97%] w-full lg:mb-0 mb-2 ">
                    <img
                      src={gear}
                      alt=""
                      className="rounded-[4%] border-none outline-none box-s lg:w-[31rem]   lg:h-[22rem] md:h-[93%] h-[17rem]  w-full object-cover  "
                    />
                  </div>

                  <div className=" lg:text-start md:text-start sm:text-center min-h-[30%] my-auto lg:w-[50%] md:w-[95%] w-[100%]">
                    <p className="lg:text-[2.6rem] text-3xl tracking-tight ">
                      <b>
                        Seamless Gear{" "}
                        <span className="text-[#2772AD]">Control </span>
                      </b>
                    </p>
                    <p className="lg:font-normal text-gray-700  text-[1.24rem]">
                      Even the smallest delay in gear shifting can point to a
                      deeper issue in your transmission system. Smooth
                      transitions aren’t just about comfort—they protect your
                      drivetrain from strain. Ignoring jerky shifts or lag can
                      escalate into gear wear, overheating, or even complete
                      failure.
                      <div className="font-bold mt-2  ">
                        {" "}
                        <Link
                          to="/contact-us"
                          className="border-b-2 text-[1.3rem] border-blue-600 hover:opacity-70"
                        >
                          Get in touch <span>&#x27A1;</span>
                        </Link>
                      </div>
                    </p>
                  </div>
                </div>
                {/* second */}
                <div className=" flex lg:flex-row md:flex-col-reverse flex-col-reverse w-full min-h-[30%] lg:my-[6%] my-[10%] justify-between  ">
                  <div className=" lg:text-start md:text-start sm:text-center my-auto  lg:w-[50%] md:w-[95%] w-[100%]">
                    <p className="lg:text-[2.6rem] md:text-3xl text-3xl tracking-tight">
                      <b>
                        Protect Internal{" "}
                        <span className="text-[#2772AD]">Systems</span>
                      </b>
                    </p>

                    <p className="leading-normal lg:font-normal text-gray-700    text-[1.3rem]">
                      Transmission repairs are some of the most expensive fixes
                      a vehicle can face. Regular maintenance and fluid checks
                      are your first line of defense. Neglecting these small
                      steps can cause gradual damage that leads to total system
                      failure and unexpected costs.
                      <div className="font-bold mt-2  ">
                        {" "}
                        <Link
                          to="/contact-us"
                          className="border-b-2 border-blue-600 hover:opacity-70"
                        >
                          Get in touch <span>&#x27A1;</span>
                        </Link>
                      </div>
                    </p>
                  </div>
                  <div className="lg:w-[50%] md:w-[97%] lg:mb-0 mb-2    flex justify-end">
                    <img
                      src={fuelchange}
                      alt=""
                      className="rounded-[4%]   lg:w-[31rem] lg:h-[22rem] md:h-[93%] h-[17rem] object-cover"
                    />
                  </div>
                </div>
                {/* third */}
                <div className="flex lg:flex-row md:flex-col flex-col w-full min-h-[30%] my-[4%]    justify-between   ">
                  <div className="lg:w-[50%] md:w-[97%] lg:mb-0 mb-2   w-full">
                    <img
                      src={fluidtransmission}
                      alt=""
                      className="rounded-[4%]   lg:w-[31rem]  lg:h-[22rem] md:h-[93%] h-[17rem] w-full object-cover  "
                    />
                  </div>

                  <div className=" lg:text-start md:text-start sm:text-center my-auto  lg:w-[50%] md:w-[95%] w-[100%]">
                    <p className="lg:text-[2.6rem] md:text-3xl text-3xl tracking-tight">
                      <b>
                        Fuel-Smart{" "}
                        <span className="text-[#2772AD]">Performance</span>
                      </b>
                    </p>

                    <p className="leading-normal lg:font-normal text-gray-700    text-[1.3rem]">
                      Every drop of fuel counts. When components like clutches
                      or gears are not functioning at peak performance, power
                      loss increases—and so does your fuel bill. What seems like
                      minor inefficiency can quietly drain your mileage and
                      overwork your engine.
                      <div className="font-bold mt-2  ">
                        {" "}
                        <Link
                          to="/contact-us"
                          className="border-b-2 border-blue-600 hover:opacity-70"
                        >
                          Get in touch <span>&#x27A1;</span>
                        </Link>
                      </div>
                    </p>
                  </div>
                </div>
              </div>

              {/* bottom: Checklist + CTA */}
              {/* <div className="lg:w-[52vw] mx-auto flex flex-col justify-between bg-white py-3 px-3 text-center rounded-2xl shadow space-y-4">
                <div>
                  <p className="text-blue-900 font-bold text-2xl md:text-3xl mb-2">
                    Is Your Car Showing These Transmission Issues?
                  </p>
                  <p className="text-lg md:text-xl mb-3">
                    Ignoring these signs can lead to{" "}
                    <span className="font-bold">total transmission failure</span>,
                    leaving you stranded with a repair bill that could have been
                    avoided.
                  </p>
                </div>

                <div className="space-y-2 text-start">
                  {[
                    "Slipping, grinding, or jerking when shifting gears",
                    "Delayed or rough gear changes",
                    "Leaking or burnt-smelling transmission fluid",
                    "Unusual noises—whistling, screeching, or clunking",
                    "Vehicle shakes or vibrates while driving",
                  ].map((issue, idx) => (
                    <div
                      key={idx}
                      className="flex items-center p-2 hover:bg-blue-50 transition"
                    >
                      <img src={check} alt="check" className="h-6 w-6 mr-4" />
                      <p className="text-blue-900 text-xl mb-0 leading-snug py-2">
                        {issue}
                      </p>
                    </div>
                  ))}
                </div>

                <div className="pt-4  ">
                  <Link to="/contact-us">
                    {/* <button className="w-full flex justify-center items-center px-4 py-3 bg-blue-600 hover:bg-blue-700 text-white text-lg font-semibold rounded-full transition">
                    Get a FREE Estimate today <FaArrowRight className="ml-3" />
                  </button> */}
              {/* <MyButton
                      text="Get a FREE Estimate today"
                      className="w-full flex justify-center items-center px-3 py-3 bg-blue-600  text-white text-lg font-semibold rounded-full transition"
                    />
                  </Link>
                </div>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
